import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import StepWizard from 'components/StepWizard';
import { getFormData } from 'store/checkout/checkoutSelectors';
import { updateFormData } from 'store/checkout/checkoutActions';

const mapStateToProps = (state) => ({
  formData: getFormData(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ updateFormData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StepWizard);
